import { render, staticRenderFns } from "./AddCartSuccess.vue?vue&type=template&id=1ee53dcf&"
import script from "./AddCartSuccess.vue?vue&type=script&lang=js&"
export * from "./AddCartSuccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports